export default __webpack_public_path__ + "static/media/jap-ecommerceImg_9.d4d5fd16.webp";